// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ruleset-shuttle-card[data-v-e9b86aba] {\n  max-height: 90vh;\n}\n.tree-wrapper[data-v-e9b86aba] {\n  flex: 1 1 auto;\n  min-height: 120px;\n  overflow-y: auto;\n}\n.ruleset-shuttle-footer[data-v-e9b86aba] {\n  border-top: 1px solid #e0e0e0;\n}\n", ""]);
// Exports
module.exports = exports;
